import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "",
    element: List,
    permissions: ["CONSIGNMENT_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["CONSIGNMENT_MODULE"],
  },
];

export default routes;
